<!-- Common KPI Progress Pop-Up -->
<template>
    <div>
        <v-dialog v-model="progressKpiDialog" max-width="900px">
          <v-card>
            <v-card-text>
              <v-container>
                    <v-row>
                        <span v-if="isEditCommonKPIProgress" style="font-weight: bold;" class="mb-2 mt-6">{{$t('performancemanagement.editcommonkpiprogress')}}</span>
                        <span v-else style="font-weight: bold;" class="mb-2 mt-6">{{$t('performancemanagement.addcommonkpiprogress')}}</span>
                    </v-row>

                    <v-row class="pb-n4 mb-n10">
                        <v-col cols="4" class="pl-0">
                            <v-text-field
                                outlined
                                :label="$t('pmreviewexercisesectioncard.reviewdate')"
                                type="date"
                                ref="reviewdate"
                                v-model="formData.reviewdate"
                                @input="updateValue"
                                dense
                                class="v-input"
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row class="pb-n4 mt-n8">
                        <v-col cols="5" class="pl-0">
                            <v-col cols="10" class="pl-0">
                                <v-text-field
                                    outlined
                                    :label="$t('pmreviewexercisesectioncard.achievement')"
                                    ref="achievement"
                                    type="number"
                                    v-model="formData.achievement"
                                    @input="handleInput"
                                    dense
                                    class="v-input"
                                ></v-text-field>
                            </v-col>
                        </v-col>
                        <v-col v-if="isEditCommonKPIProgress" cols="3" class="pl-0">
                            <v-col class="pl-0">
                                <v-text-field
                                    outlined
                                    :label="$t('pmreviewexercisesectioncard.progressInPercentage')"
                                    type="number"
                                    v-model="formData.progress"
                                    @input="updateValue"
                                    dense
                                    class="v-input"
                                    readonly
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>
                        </v-col>
                    </v-row>

                    <v-row class="mt-n1 pb-n4 mt-n8">
                        <v-text-field
                            outlined
                            :label="$t('performancemanagement.comments')"
                            ref="comments"
                            type="text"
                            v-model="formData.comments"
                            @input="updateValue"
                            dense
                            class="v-input"
                        ></v-text-field>
                    </v-row>

              </v-container>
            </v-card-text>

            <v-card-text v-if="isErr" class="mt-n12">
                <span style="font-weight: bold; color: red">{{errMsg}}</span>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="saveProgressKpiInput">{{$t('button.save')}}</v-btn>
              <v-btn color="red darken-1" text @click="closeProgressKpiInput">{{$t('button.cancel')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-container class="overflow-y-auto">
            <v-row class="mt-4">
                <v-col cols="4" sm="10" class="pb-n5 mt-n8 ml-3">
                    <v-toolbar flat>
                        <v-row class="blue--text">
                            <v-btn color="primary" dark @click="openProgressKpiInput">+</v-btn>
                        </v-row>
                    <v-spacer></v-spacer>
                    </v-toolbar>
                </v-col>
            </v-row>

            <v-row  class="ml-0">
                <v-data-table
                    :headers="this.parentObject.tabHeader"
                    :items="progressCommonKpiListdetail"
                    class="elavation-1"
                    fixed-header
                    :sort-by="['code']"
                >
                    <template v-slot:[`item.action`]="{ item }">
                        <v-icon
                            small
                            class="ml-2 mr-2"
                            @click="modifyItemHandler(item)"
                        >
                            mdi-pen
                        </v-icon>
                        <v-icon
                            small
                            class="mr-2"
                            @click="deleteItemHandler(item)"
                        >
                            mdi-delete
                        </v-icon>
                    </template>
                </v-data-table>
            </v-row>
        </v-container>

        <div v-if="isErr">
        <app-error
            v-bind:parentError="{
            data: this.errMsg,
            isErr: this.isErr,
            }"
            v-on:closeError="isErr = $event"
        />
        </div>
    </div>
</template>

<script>
import moment from "moment";
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
    props: {
        parentObject: Object
    },

    components: {
        "app-error": ErrorDialog,
    },

    data() {
        return {
            publicPath: process.env.BASE_URL,

            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
            },

            progressCommonKpiListdetail: [],
            calcMethod: this.parentObject.calcMethod,
            target: this.parentObject.target,

            kpiprogressid: null,
            commonkpiid: this.parentObject.formData.commonkpiid,
            formData: {
                ...this.parentObject.formData,
            },

            progressKpiDialog: false,
            
            //error msg and dialog, check for duplicates vars
            isErr: false,
            isEditCommonKPIProgress: false,
            errMsg: '',
        }
    },

    methods: {
        modifyItemHandler(item) {
            this.loadKpiProgressHandler(item)
            this.isEditCommonKPIProgress = true;
            this.progressKpiDialog = true;
        },

        loadKpiProgressHandler(item) {
            this.resetFormData();
            this.kpiprogressid = item.id;
            this.formData = item;
        },

        //load kpi common list handler
        async loadKpiCommonListHandler() {
            const vm = this;

            await this.$store.dispatch('get', {url: "/kpicommonprogress/" + vm.$route.params.id})
            .then((res) => {

                for(let i = 0; i < res.data.rec.length; i++) {
                    
                    if(res.data.rec[i].reviewdate){
                        res.data.rec[i].reviewdate = moment(res.data.rec[i].reviewdate).format('YYYY-MM-DD');
                    }
                }

                vm.progressCommonKpiListdetail = res.data.rec;
            })
            .catch((err) => {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
            });
        },

        deleteItemHandler(item) {
            const vm = this;
            if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
                return false;
            }

            if (confirm(this.$t('performancemanagement.deleteprogress', { code: item.reviewdate }))) {
                this.$store.dispatch('delete', {
                    url: "/kpicommonprogress/" + item.id + '/' + this.$store.getters.userId
                })
                .then((res) => {
                if (res.data.error) {
                    vm.isErr = !vm.isErr;
                    vm.errMsg = res.data.error;
                } else {
                    let itemIndex = this.progressCommonKpiListdetail.indexOf(item);
                    this.progressCommonKpiListdetail.splice(itemIndex, 1);
                }
                })
                .catch((err) => {
                    vm.isErr = !vm.isErr;
                    vm.errMsg = err;
                });
            }
        },

        openProgressKpiInput() {
            this.progressKpiDialog = true;
        },

        handleInput() {
            this.updateValue();
            this.updateProgress();
        },

        updateProgress() {
            this.formData.progress = this.calculateProgress(this.formData.achievement, this.calcMethod, this.target);
        },

        calculateProgress(achievement, calcMethod, target) {
            if (calcMethod == 1) {
                return (achievement / target) * 100;
            } else if (calcMethod == 2) {
                return (target / achievement) * 100;
            }
        },

        async saveProgressKpiInput() {
            const vm = this;

            if(vm.isEditCommonKPIProgress) {

                if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
                    return false;
                }

                vm.formData.userid = vm.$store.getters.userId;

                await vm.$store.dispatch('put', {url: "/kpicommonprogress/" + vm.kpiprogressid, payload: vm.formData})
                .then((res) => {
                    if (res.data.error) {
                        vm.isErr = true;
                        if (Array.isArray(res.data.error)) {
                            vm.errMsg = res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n');
                        } else {
                            vm.errMsg = res.data.error;
                        }
                    }
                    else{
                        vm.isErr = false;
                        vm.resetFormAndReload();
                    }
                })
                .catch((err) => {
                    vm.isErr = true;
                    vm.errMsg = err;
                });

            } else { //Add New

                if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
                    return false;
                }

                await this.$store.dispatch('post', {url: "/kpicommonprogress/create", payload: vm.formData})
                .then((res) => {
                    if (res.data.error) {
                        vm.isErr = true;
                        if (Array.isArray(res.data.error)) {
                            vm.errMsg = res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n');
                        } else {
                            vm.errMsg = res.data.error;
                        }
                    } else {
                        let item = res.data.rec;

                        if (item.reviewdate) {
                            item.reviewdate = moment(item.reviewdate).format('YYYY-MM-DD');
                        }

                        vm.progressCommonKpiListdetail.push(item);
                        vm.isErr = false;
                        vm.resetFormAndReload();
                    }
                })
                .catch((err) => {
                    vm.isErr = true;
                    vm.errMsg = err;
                });
            }
        },

        // Method to reset form and reload
        resetFormAndReload() {
            // Reset the form fields
            this.progressKpiDialog = false;
            this.isEditCommonKPIProgress = false;
            this.resetFormData();
            window.history.back();
        },

        closeProgressKpiInput() {
            this.isEditCommonKPIProgress = false;
            this.progressKpiDialog = false;
            this.isErr = false;
            console.log("this",this.parentObject);

            // reset the form fields
            this.resetFormData();
        },

        resetFormData() {
            this.formData = {
                commonkpiid: this.commonkpiid,
                reviewdate: null,
                achievement: null,
                comments: null,
                stamp: 0,
                userid: this.$store.getters.userId,
                progress: null
            }
        },
        
        updateValue() {
            this.$emit('input', {
                commonkpiid: this.commonkpiid,
                reviewdate: null,
                achievement: null,
                comments: null,
                stamp: 0,
                userid: this.$store.getters.userId,
                progress: null
            });
        },
    },
    mounted() {
        this.loadKpiCommonListHandler();
    }
}
</script>

<style scoped>

.v-input .v-input__control .v-input__slot .v-text-field__slot input::-webkit-outer-spin-button,
.v-input .v-input__control .v-input__slot .v-text-field__slot input::-webkit-inner-spin-button
{
-webkit-appearance: none;
margin: 0;
}

.mdi-delete::before {
    margin-top: -8px;
}

.mdi-pen::before {
  margin-top: -8px;
}
</style>